import Vue from "vue"
import Vuex from "vuex"
import auth from "./modules/auth"
import system from "./modules/system"
import app from "./modules/app"
import projectPre from "./modules/projectPre/index"
import createPersistedState from "./plugins/persistence"
// import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    system,
    app,
    projectPre
  },
  plugins: [createPersistedState]
})



// WEBPACK FOOTER //
// ./src/store/index.js